import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../app/store";
import { EDeductionStatus } from "../api/Deduction/EDeductionStatus";
import { EDeductionCategory } from "../api/Deduction/EDeductionCategory";
import { DeductionQueryParams } from "../api/Deduction/DeductionQueryParams";
import { Deduction } from "../api/Deduction/Deduction";
import { PagedList } from "../api/Api";
import { getDeductions } from "../api/Deduction/DeductionApi";

interface DeductionsState {
  deductionsById: Record<string, Deduction>;
  currentPageDeductions: string[];

  isLoading: boolean;
  error: string | null;

  queryParams: DeductionQueryParams;
  pageCount: number;
  total: number;
}

const initialState: DeductionsState = {
  deductionsById: {},
  currentPageDeductions: [],
  isLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
  queryParams: {
    page: 1,
    ascending: true
  }
};

function startLoading(state: DeductionsState) {
  state.isLoading = true;
}

function loadingFailed(state: DeductionsState, action: PayloadAction<string>) {
  state.isLoading = false;
  state.error = action.payload;
}

const deductions = createSlice({
  name: "deductions",
  initialState,
  reducers: {
    getDeductionsStart: startLoading,
    getDeductionsSuccess(state, { payload }: PayloadAction<PagedList<Deduction>>) {
      const { items } = payload;

      state.isLoading = false;
      state.error = null;

      items.forEach((q) => {
        state.deductionsById[q.id] = q;
      });
    },
    getDeductionsFailure: loadingFailed,
    setQueryParams(state, { payload }: PayloadAction<DeductionQueryParams>) {
      state.queryParams = payload;
    }
  }
});

export const { getDeductionsStart, getDeductionsSuccess, getDeductionsFailure, setQueryParams } = deductions.actions;

export default deductions.reducer;

export const fetchDeductions = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getDeductionsStart());
    var queryParams: DeductionQueryParams = {
      page: 1,
      pageSize: 100,
      category: EDeductionCategory.Discount,
      status: EDeductionStatus.Active,
      ascending: true
    };
    const deductions = await getDeductions(queryParams);
    dispatch(getDeductionsSuccess(deductions));
  } catch (err: any) {
    dispatch(getDeductionsFailure(err.toString()));
  }
};
